import { QueryParamsType } from "src/types/query-params";
import qs from "qs";
import useRequest from "../useRequest";
import { IDeliveryman } from "src/types";

export const useDeliverymen = (query: Record<string, QueryParamsType>) => {
    const url = `/delivery-man?${qs.stringify(query)}`;
    const { data, mutate, isLoading, error, ...rest } = useRequest(url, url);
    return {
        deliverymen: (data as Array<IDeliveryman>) || [],
        mutate,
        isLoading,
        error,
        ...rest,
    };
};
